import React, { Fragment } from 'react';
import { Header, Segment, Form, Loader, Table, Popup, Button, Icon, Input } from 'semantic-ui-react';
import axios from 'axios';
import { fetchFaculties } from '../../Lookups/util';
import { FormattedMessage } from 'react-intl';
import { toast, ToastContainer } from 'react-toastify';
import PaginationFront from '../../util/PaginationFront';
import SearchTableData from '../../util/SearchTableData';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

export default class CourseBasicHR extends React.Component {
    constructor(props) {
        super(props);
        let storedOrgUnitId = '';

        if (localStorage.getItem('orgUnitId')) {
            storedOrgUnitId = parseInt(localStorage.getItem('orgUnitId'), 10);
        }

        this.state = {
            courseBasics: [],
            orgUnits: [],
            orgUnitId: storedOrgUnitId,
            results: [],

            loading: false,
            saving: false,

            addingRowData: null,
            editingRowData: null,
            deletingRowId: null,

            activePage: 1,
            postsPerPage: 20,
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.fetchCourseBasicNew = this.fetchCourseBasicNew.bind(this);
        this.getDataToRender = this.getDataToRender.bind(this);
        this.getResults = this.getResults.bind(this);

    }


    componentDidMount() {
        fetchFaculties()
            .then(((orgUnitsRes) => {
                const orgUnits = orgUnitsRes.data.map(el => ({
                    ...el,
                    key: el.id,
                    value: el.id,
                    text: el.name
                }));
                this.setState({ orgUnits });
            }))
            .catch(err => {
                this.setState({ error: true });
                // console.log('Failed to fetch org. units');
            });

        if (localStorage.getItem('orgUnitId')) {
            this.fetchCourseBasicNew();
        }
    }

    fetchCourseBasicNew = () => {
        this.setState({ loading: true });
        axios.get(`/course-basic-new/${this.state.orgUnitId}/`)
            .then((res) => {
                // console.log(res.data);
                this.setState({
                    courseBasics: res.data,
                    loading: false
                });
            });
    };

    handleInputChange(event, {
        name,
        value
    }) {
        this.setState({
            [name]: value,
        }, () => {
            localStorage.setItem('orgUnitId', value);
            if (value) {
                this.resetRowStates();
            } else {
                this.setState({ courseBasics: [] });
            }
            this.setState({ activePage: 1 });
        });
    }

    handleAddClick = () => {
        const obj = {
            id: -1,
            name: '',
            organizationalUnitId: this.state.orgUnitId,
        };
        this.setState({
            addingRowData: obj,
            // courseBasics: [obj, ...this.state.courseBasics],
            // results: [obj, ...this.state.results]
        });
        if (this.state.results.length > 0) {
            this.setState({
                results: [obj, ...this.state.results]
            });
        } else {
            this.setState({
                courseBasics: [obj, ...this.state.courseBasics]
            });
        }
    };

    handleEditClick = (courseBasic) => {
        this.setState({
            editingRowData: {
                id: courseBasic.id,
                name: courseBasic.name,
                organizationalUnitId: courseBasic.organizationalUnit.id
            }
        });
    };

    handleDeleteClick = (courseBasic) => {
        this.setState({
            deletingRowId: courseBasic.id
        });
    };

    resetRowStates = () => {
        this.setState({
            addingRowData: null,
            editingRowData: null,
            deletingRowId: null,
            saving: false,
            activePage: 1,
            results: [],
        }, () => {
            this.fetchCourseBasicNew();
        });
    };

    handleSaveClick = () => {
        this.setState({ saving: true });
        var axiosCall = null;
        if (this.state.addingRowData) {
            axiosCall = axios.post('/course-basic-new/', this.state.addingRowData);
        } else if (this.state.editingRowData) {
            axiosCall = axios.put(`/course-basic-new/`, this.state.editingRowData);
        } else if (this.state.deletingRowId) {
            axiosCall = axios.delete(`/course-basic-new/${this.state.deletingRowId}/`);
        }

        if (axiosCall) {
            axiosCall
                .then((res) => {
                    let toastMessage = '';
                    if (this.state.addingRowData) {
                        toastMessage = 'Predmet je uspješno dodan.';
                    } else if (this.state.editingRowData) {
                        toastMessage = 'Predmet je uspješno uređen.';
                    } else if (this.state.deletingRowId) {
                        toastMessage = 'Predmet je uspješno obrisan.';
                    }
                    toast(toastMessage);
                    this.resetRowStates();
                })
                .catch((err) => {
                    this.setState({ saving: false });
                    const errorMsg = err && err.response && err.response.data ? err.response.data : '';

                    if (errorMsg.includes('already exists')) {
                        toast('Predmet sa istim nazivom već postoji u ovoj organizacionoj jedinici.');
                    } else {
                        toast('Došlo je do greške.');
                    }
                });
        }
    };

    handleCancelClick = () => {
        this.setState({
            addingRowData: null,
            editingRowData: null,
            deletingRowId: null,
            courseBasics: this.state.courseBasics.filter(cb => cb.id !== -1)
        });
    };

    getResults(results) {
        this.setState({ results });
        this.handlePaginationChange({}, { activePage: 1 });
    }

    getDataToRender() {
        if (this.state.results.length !== 0) {
            return this.state.results;
        }
        return this.state.courseBasics;
    }

    handlePaginationChange = (e, { activePage }) => this.setState({ activePage });


    render() {
        const {
            loading,
            orgUnitId,
            orgUnits,
            courseBasics,
            saving,
            addingRowData,
            editingRowData,
            deletingRowId,
        } = this.state;

        const localStorageRole = localStorage.getItem('activeRole') || '';
        const disabledProp = addingRowData || editingRowData || deletingRowId;

        const indexOfLastPost = this.state.activePage * this.state.postsPerPage;
        const indexOfFirstPost = indexOfLastPost - this.state.postsPerPage;
        const currentPosts = this.getDataToRender()
            .slice(indexOfFirstPost, indexOfLastPost);

        return (
            <div>
                <Header as="h1">HR - Predmeti</Header>

                <Segment.Group raised>
                    <Segment raised>
                        <Header as="h3">
                            Odabir organizacione jedinice
                        </Header>
                    </Segment>
                    <Segment>
                        <Form>
                            <Form.Group widths="equal">
                                <Form.Field>
                                    <label>Organizaciona jedinica</label>
                                    <Form.Dropdown
                                        clearable
                                        placeholder="Odaberite organizacionu jedinicu"
                                        value={localStorage.getItem('orgUnitId') ? parseInt(localStorage.getItem('orgUnitId'), 10) : orgUnitId}
                                        onChange={this.handleInputChange}
                                        name="orgUnitId"
                                        options={orgUnits}
                                        search
                                        fluid
                                        selection
                                    />
                                </Form.Field>
                                <Form.Field/>
                            </Form.Group>
                        </Form>
                    </Segment>
                    <Segment>
                        {
                            loading
                                ? <div style={{
                                    paddingTop: '100px',
                                    paddingBottom: '100px'
                                }}>
                                    <Loader active inline="centered"/>
                                </div>
                                : orgUnitId && <Table selectable celled compact verticalAlign={'middle'}>
                                <Table.Header>
                                    <Table.HeaderCell colSpan={13}>
                                        <SearchTableData profMozilla data={this.state.courseBasics}
                                                         getResults={this.getResults} filterItem={['name']}
                                                         disabled={disabledProp}/>
                                    </Table.HeaderCell>
                                    <Table.Row>
                                        <Table.HeaderCell colSpan={1}>R. br.</Table.HeaderCell>
                                        <Table.HeaderCell colSpan={10}>Naziv</Table.HeaderCell>
                                        <Table.HeaderCell colSpan={2} textAlign={'center'}>
                                            <Popup
                                                content={'Dodaj novi predmet'}
                                                position="top center"
                                                trigger={
                                                    <Button
                                                        basic
                                                        circular
                                                        icon
                                                        size="tiny"
                                                        color="blue"
                                                        onClick={this.handleAddClick}
                                                        disabled={disabledProp}
                                                    >
                                                        <Icon name="plus"/>
                                                    </Button>
                                                }
                                            />
                                        </Table.HeaderCell>
                                    </Table.Row>
                                </Table.Header>
                                <Table.Body>
                                    {
                                        currentPosts && currentPosts.length > 0 ? currentPosts.map((courseBasic, index) => (
                                            <Table.Row key={courseBasic.id}>
                                                <Table.Cell verticalAlign={"middle"} colSpan={1}>{index + 1}.</Table.Cell>
                                                <Table.Cell verticalAlign={"middle"} colSpan={10}>
                                                    {
                                                        addingRowData && addingRowData.id === courseBasic.id
                                                        || editingRowData && editingRowData.id === courseBasic.id
                                                            ?
                                                            <Form.Field>
                                                                <Input
                                                                    fluid
                                                                    placeholder="Naziv predmeta"
                                                                    value={addingRowData && addingRowData.id === courseBasic.id
                                                                        ? addingRowData.name
                                                                        : editingRowData && editingRowData.id === courseBasic.id
                                                                            ? editingRowData.name
                                                                            : ''}
                                                                    onChange={(e, { value }) => {
                                                                        if (addingRowData && addingRowData.id === courseBasic.id) {
                                                                            this.setState({
                                                                                addingRowData: {
                                                                                    ...addingRowData,
                                                                                    name: value
                                                                                }
                                                                            });
                                                                        } else if (editingRowData && editingRowData.id === courseBasic.id) {
                                                                            this.setState({
                                                                                editingRowData: {
                                                                                    ...editingRowData,
                                                                                    name: value
                                                                                }
                                                                            });
                                                                        }
                                                                    }}
                                                                />
                                                            </Form.Field>
                                                            : courseBasic.name
                                                    }</Table.Cell>
                                                <Table.Cell colSpan={2} textAlign="center" verticalAlign={'middle'}>
                                                    {addingRowData && addingRowData.id === courseBasic.id
                                                    || editingRowData && editingRowData.id === courseBasic.id
                                                    || deletingRowId === courseBasic.id ? (
                                                        <Fragment>
                                                            <Popup
                                                                content={'Sačuvaj'}
                                                                position="top center"
                                                                trigger={<Button
                                                                    circular
                                                                    icon
                                                                    size="tiny"
                                                                    color="blue"
                                                                    onClick={this.handleSaveClick}
                                                                    disabled={saving}
                                                                    loading={saving}
                                                                >
                                                                    <Icon name="check"/>
                                                                </Button>}/>
                                                            <Popup
                                                                content={'Odustani'}
                                                                position="top center"
                                                                trigger={<Button
                                                                    basic
                                                                    circular
                                                                    icon
                                                                    size="tiny"
                                                                    color="blue"
                                                                    onClick={this.handleCancelClick}
                                                                    disabled={saving}
                                                                >
                                                                    <Icon name="close"/>
                                                                </Button>}/>
                                                        </Fragment>
                                                    ) : (
                                                        <Fragment>
                                                            <Popup
                                                                content={'Uredi predmet'}
                                                                position="top center"
                                                                trigger={<Button
                                                                    basic
                                                                    circular
                                                                    icon
                                                                    size="tiny"
                                                                    color="green"
                                                                    onClick={() => this.handleEditClick(courseBasic)}
                                                                    disabled={disabledProp}
                                                                >
                                                                    <Icon name="pencil"/>
                                                                </Button>}/>
                                                            <Popup
                                                                content={'Obriši predmet'}
                                                                position="top center"
                                                                trigger={<Button
                                                                    basic
                                                                    circular
                                                                    icon
                                                                    size="tiny"
                                                                    color="red"
                                                                    onClick={() => this.handleDeleteClick(courseBasic)}
                                                                    disabled={disabledProp}
                                                                >
                                                                    <Icon name="trash alternate"/>
                                                                </Button>}/>
                                                        </Fragment>
                                                    )}
                                                </Table.Cell>
                                            </Table.Row>
                                        )) : (
                                            <Table.Row>
                                                <Table.Cell colSpan={13} textAlign="left">
                                                    Nema podataka za prikaz.
                                                </Table.Cell>
                                            </Table.Row>
                                        )
                                    }
                                </Table.Body>
                            </Table>
                        }
                        {currentPosts.length > 0 && !loading &&
                            <PaginationFront postsPerPage={this.state.postsPerPage}
                                             totalPosts={this.getDataToRender().length}
                                             paginate={this.handlePaginationChange}
                                             activePage={this.state.activePage}
                                             disabled={disabledProp}/>}
                    </Segment>
                </Segment.Group>
                <ToastContainer hideProgressBar position={'top-right'}/>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Admin/CourseBasicHR/CourseBasicHR.js